exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".hMsTM7QUTKx2U-sNHQsja{box-sizing:border-box;display:block;height:60px;left:0;padding:20px 15px;position:absolute;top:-60px}.hMsTM7QUTKx2U-sNHQsja:active{opacity:.9}.hMsTM7QUTKx2U-sNHQsja svg{display:block;height:20px;width:auto}", ""]);

// exports
exports.locals = {
	"logo": "hMsTM7QUTKx2U-sNHQsja"
};